module.exports = __webpack_public_path__ + "img/path-crosses.7e2745f2.svg";